<div class="suggestion">{{ 'SuggestionMessages.SearchResultExpired' | translate }}</div>
<div class="actions">
  <button class="btn btn-primary" (click)="startSearching()">{{ 'Common.Begin' | translate }}</button>
  <button class="btn btn-danger" (click)="close()">{{ 'Common.Close' | translate }}</button>
</div>
